import MainSchema, { MainType, MemberType } from './ContactRelatedApiZodSchema';
import { useEffect, useState } from "react";
import { axiosFunction } from "../components/commonFunctions";
import { v2ReactURL } from "../utils/constant";
export type ExtendedMemberType = MemberType & { id:number; name: string };
const useContactRelatedApi = (tabView: string) => {
  const [contactRelatedData, setContactRelatedData] = useState<Partial<MainType>>({});
  const [searchMembershipResults, setSearchMembershipResults] = useState<ExtendedMemberType[]>([]);
  const [membershipList, setMembershipList] = useState<ExtendedMemberType[]>([]);

  const [loadingContactData, setLoadingContactData] = useState(true);

  useEffect(() => {
    const fetchContactRelatedList = async (_tabView: string) => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/list?type=contact`,
        "GET"
      );
      // console.log("sdfghj",res?.data)
      const validatedData = MainSchema.safeParse(res?.data);
       
      if (validatedData.success) {
          setLoadingContactData(false);
         
          const modifiedResults = validatedData.data?.membershiplist?.map((row:MemberType) => {
            return {
              ...row,
              id: row.membershipId,
              name: row.membershipName,
            }as ExtendedMemberType;
          });
  
          setContactRelatedData(validatedData.data);
          setSearchMembershipResults(modifiedResults || []);
          setMembershipList(modifiedResults || []);
      }else {
        console.error("API response validation failed:", validatedData.error);
      }
    };

    fetchContactRelatedList(tabView);
  }, []);

  return {
    searchMembershipResults,
    membershipList,
    setMembershipList,
    contactRelatedData,
    loadingContactData,
  };
};

export default useContactRelatedApi;
